// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"231":"checkout","443":"about","596":"404","907":"history-detail","908":"history"}[chunkId] || chunkId) + "." + {"231":"efca0307","263":"6697a37e","443":"1039d305","596":"2a77447b","879":"7702f1ae","881":"77ebb226","907":"f3c1cff6","908":"3407a50b"}[chunkId] + ".js";
};